<template>
	<div class='knd-header' ref='landing'>

		<div class='knd-contrain knd-header__content'>
			<div class='p-t-lg'>
				<h1 class='knd-header__title knd-ta-center m-b-md article-hero__title knd-txt-sh'>
					{{landing.titel}}
				</h1>
			</div>

			<div class='knd-header-image'>
				<img src='@/assets/icons/bang.svg' 
				/> 
			</div>
			
			<div class='knd-header__lead m-t-md m-b-lg knd-ta-center knd-txt-sh' v-html="landing.intro">
			</div>

			<div class='knd-header__scroll knd-ta-center animate-bounce' v-on:click="nextStep">
				<img src='@/assets/icons/scroll.svg' /> 
			</div>
		</div>
	</div>
</template>

<script>
export default {

	name: 'kndheader',

	computed: {
		landing () {
			return this.$store.state.data.landing;
		}
	},
	created: function() {
		window.scrollTo(0,0);
	},

	mounted: function(){
		let scrollEnd = false;
		const processChange = this.debounce(() => { scrollEnd = true}, 300);


		window.onscroll = (ev) => {
			if ((window.innerHeight + window.pageYOffset) >= document.body.offsetHeight) {
				console.log("you're at the bottom of the page");
				if(scrollEnd) {
					this.nextStep()
				}

				processChange();
			} else {
				scrollEnd = false;
			}
		};

	},

	methods: {
		debounce(func, timeout = 300){
			let timer;
			return (...args) => {
				clearTimeout(timer);
				timer = setTimeout(() => { func.apply(this, args); }, timeout);
			};
		},

		isEndOfElement(element){
		//visible height + pixel scrolled = total height 
			return element.offsetHeight + element.scrollTop >= element.scrollHeight;
		},

		nextStep: function() {
			this.$router.push({ name: 'standpunt'})
		}
	}
}
</script>

<style lang="css" scoped>
</style>